<route>
{
  "name": "profile",
  "meta": {
    "order": 10,
    "isVisible": true,
    "iconName": "mdi-account-circle-outline"
  }
}
</route>

<template>
  <div>
    <member-info
      v-if="userInfo"
      class="mt-16"
      :avatar="userInfo.avatarImage || '/img/default-avatar.jpg'"
      :name="userInfo.name"
      :email="userInfo.phone"
      :description="$t('general.wellcome_member')"
    />
  </div>
</template>

<script>
import faker from 'faker'
faker.locale = 'fa'
export default {
  name: 'pageProfile',
  layout: APP_CONFIG.layout.mainPanelLayout,
}
</script>
